import ReactApexChart from "react-apexcharts";
import { Card, CardBody, Col } from "reactstrap";
import { FinanceTitle } from "../../../../Constants/Constants";
import { FinanceChart } from "../../../../Data/General/Widgets/Chart";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";

const Finance = () => {
  return (
    <Col xl="5" lg="12" className="box-col-5">
      <Card>
        <CommonCardHeader title={FinanceTitle} />
        <CardBody>
          <div className="chart-container column-container">
            <div id="columnchart">
              <ReactApexChart options={FinanceChart} series={FinanceChart.series} height={350} type="line" />
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default Finance;
